import strFunc from "@/lib/lyg/string";
import TodoArrTable from "./todo_arr";

function TodoArea(props: any) {
  let myProps = {
    style: {},
    user: {},
    stu_info: {},
    select_date: "",
    subject_name: "",
    callback: (inData: any) => { },
    td_sort_data_arr: [],
    on_change_todo: (inData: any) => { },
    on_delete_todo: (inData: any) => { },
    add_todo_arr: [],
    set_add_todo_arr: (inData: any) => { },
    add_new_todo_row_by_ajax: (inData: any) => { },
    check_todo_pri_val_arr: [],
    set_check_todo_pri_val_arr: (inData: any) => { },
    openTodoWriteOnePopup: (inData: any) => { },
    open_todo_word_result_one_popup: (inData: any) => { },
    ...props
  };
  let user = myProps.user;

  const on_check_all_todo = (e: any) => {
    let is_checked = e.target.checked;
    if (is_checked) {
      let change_todo_pri_val_arr = [];
      for (let s_i = 0; s_i < myProps.td_sort_data_arr.length; s_i++) {
        let sort_data = myProps.td_sort_data_arr[s_i];
        for (let i = 0; i < sort_data.todo_info_arr.length; i++) {
          let todo_info = sort_data.todo_info_arr[i];
          let todo_pri_val = todo_info.row_pri_val;
          change_todo_pri_val_arr.push(todo_pri_val);
        }
      }
      myProps.set_check_todo_pri_val_arr(change_todo_pri_val_arr);
    } else {
      myProps.set_check_todo_pri_val_arr([]);
    }
  };

  let get_todo_arr_tags = () => {
    let todo_arr_tags = myProps.td_sort_data_arr.map((sort_data: any, idx: number) => {
      return (
        <TodoArrTable
          key={idx}
          user={user}
          stu_info={myProps.stu_info}
          select_date={myProps.select_date}
          subject_name={myProps.subject_name}
          callback={myProps.callback}
          style={myProps.style}
          sort_data={sort_data}
          todo_arr={sort_data.todo_info_arr}
          on_change_todo={myProps.on_change_todo}
          on_delete_todo={myProps.on_delete_todo}
          add_todo_arr={myProps.add_todo_arr}
          set_add_todo_arr={myProps.set_add_todo_arr}
          add_new_todo_row_by_ajax={myProps.add_new_todo_row_by_ajax}
          check_todo_pri_val_arr={myProps.check_todo_pri_val_arr}
          set_check_todo_pri_val_arr={myProps.set_check_todo_pri_val_arr}
          openTodoWriteOnePopup={myProps.openTodoWriteOnePopup}
          open_todo_word_result_one_popup={myProps.open_todo_word_result_one_popup}
        ></TodoArrTable>
      );
    });
    if (todo_arr_tags == "") {
      todo_arr_tags = (
        <div className="text-center mt-5">
          플랜이 없습니다.
        </div>
      );
    }
    return todo_arr_tags;
  };

  return (
    <div>
      <div style={{ width: "95%", margin: "0 auto", position: "relative" }}>
        <label>
          <input type="checkbox" className="search-input"
            onChange={on_check_all_todo}
          />
          <span className="ml-1">전체</span>
        </label>
        <span style={{ position: "absolute", right: 0 }}>
          <button className="btn btn-red"
            onClick={() => {
              let check_todo_info_arr = [];
              for (let s_i = 0; s_i < myProps.td_sort_data_arr.length; s_i++) {
                let sort_data = myProps.td_sort_data_arr[s_i];
                for (let i = 0; i < sort_data.todo_info_arr.length; i++) {
                  let todo_info = sort_data.todo_info_arr[i];
                  if (strFunc.str_in_array(todo_info.row_pri_val, myProps.check_todo_pri_val_arr) != -1) {
                    check_todo_info_arr.push(todo_info);
                  }
                }
              }
              myProps.on_delete_todo({ todo_info_arr: check_todo_info_arr });
            }}
          > 선택삭제</button>
        </span>
      </div>
      {get_todo_arr_tags()}
    </div >
  );
};
export default TodoArea;